import { render, staticRenderFns } from "./addOaidFile.vue?vue&type=template&id=ed786f18&scoped=true&"
import script from "./addOaidFile.vue?vue&type=script&lang=js&"
export * from "./addOaidFile.vue?vue&type=script&lang=js&"
import style0 from "./addOaidFile.vue?vue&type=style&index=0&id=ed786f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed786f18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed786f18')) {
      api.createRecord('ed786f18', component.options)
    } else {
      api.reload('ed786f18', component.options)
    }
    module.hot.accept("./addOaidFile.vue?vue&type=template&id=ed786f18&scoped=true&", function () {
      api.rerender('ed786f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addOaidFile.vue"
export default component.exports